"use strict";

exports.__esModule = true;
exports.AdvancedTimelineSubscription = AdvancedTimelineSubscription;
var _react = _interopRequireDefault(require("react"));
var _RealtimeConnection = require("../../API/RealtimeConnection");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AdvancedTimelineSubscription(props) {
  var device = props.device,
    timeline = props.timeline,
    children = props.children,
    onData = props.onData,
    _props$kind = props.kind,
    kind = _props$kind === void 0 ? "timeline" : _props$kind;
  return /*#__PURE__*/_react["default"].createElement(_RealtimeConnection.RealtimeDataSubscription, {
    params: [kind, {
      entity: {
        device: device,
        name: timeline
      },
      isCurrent: true
    }],
    onData: onData
  }, children);
}